import React from "react";
import Header from './Header';
import Pcdesk from './Pcdesk';
import Ovision from './Ourvision';
import Aboutus from './Aboutus';
import OurP from './OurPrograms';
import UpcomingEvents from './UpcomingEvents';

const Home = () => {
    return <div>
      <Header />
      <Pcdesk />
      <Ovision />
      <Aboutus />
      <OurP />
      <UpcomingEvents />
    </div>;
};

export default Home;